export default "__VITE_ASSET__Kw6W6Au2__"